import React from 'react';
import ProductPage from '../components/product-page';

export default function PmpPage() {
  return (
    <ProductPage
      title="Panelboards with Smart Control"
      className="smart-power-commercial"
      demoLink="http://benjaminelectric.com/bci"
      images={[
        {
          src: 'bcp-side-view.png',
          alt: 'Grey panelboard with door open',
        },
        {
          src: 'bcp-overview.png',
          alt: 'Sample image of web interface for smart control',
        },
        {
          src: 'pmi-timers.png',
          alt: 'Sampmle image of scheduling for circuit control',
        },
      ]}
      sections={[
        {
          title: 'Description',
          id: 'description',
          content: (
            <>
              An efficient addition to your Lighting Controls and Energy
              Management Systems. The Breaker Control Panel uses remote
              controllable breakers which add key functionality to your energy
              reduction programs.
            </>
          ),
        },
        {
          title: 'Features',
          id: 'features',
          content: (
            <ul>
              <li>
                Remotely operate circuit breakers via manual or automated
                control schemes
              </li>
              <li>
                Breakers turn on sequentially to reduce in-rush current impacts
                from LED driver loads
              </li>
              <li>
                Industry Standard communication protocols are supported for
                integration with Building Management Systems or use the built in
                scheduler to control circuits.
              </li>
              <li>
                Built to order, customized to your specifications, including
                retrofit upgrades to existing enclosures.
              </li>
            </ul>
          ),
        },
        {
          title: 'Specifications',
          id: 'specifications',
          content: (
            <>
              <table>
                <tbody>
                  <tr>
                    <th>Voltage Ratings</th>
                    <td>120/240V 1Ø 3W</td>
                    <td>208Y/120V 3Ø 4W</td>
                    <td>480Y/277V 3Ø 4W</td>
                  </tr>
                </tbody>
              </table>
              <table id="aic_ratings">
                <tbody>
                  <tr>
                    <th rowSpan="2">AIC Ratings</th>
                    <td className="left-align">
                      65kAIC@240V Fully Rated to 100kAIC Series Rated
                    </td>
                  </tr>
                  <tr>
                    <td className="left-align">
                      14kAIC@480Y/277V Fully Rated to 65kAIC Series Rated
                    </td>
                  </tr>
                  <tr></tr>
                </tbody>
              </table>

              <table id="breaker_options">
                <tbody>
                  <tr>
                    <th rowSpan="3">Branch Circuit Breaker Options</th>
                    <td>1 Pole</td>
                    <td className="left-align">
                      Ratings: 15A, 20A, 30A Controlled, 15A to 100A
                      non-controlled
                    </td>
                  </tr>
                  <tr>
                    <td>2 Pole</td>
                    <td className="left-align">
                      Ratings: 15A, 20A, 30A Controlled, 15A to 100A
                      non-controlled
                    </td>
                  </tr>
                  <tr>
                    <td>3 Pole</td>
                    <td className="left-align">
                      Ratings: 15A to 100A non-controlled
                    </td>
                  </tr>
                </tbody>
              </table>

              <table id="main_options">
                <tbody>
                  <tr>
                    <th rowSpan="2">Mains Configurations</th>
                    <td>Lugs</td>
                    <td className="left-align">
                      Ratings: 100A, 225A, 400A, and 600A Rated
                    </td>
                  </tr>
                  <tr>
                    <td>Breaker</td>
                    <td className="left-align">
                      Ratings: 100A, 225A, 400A, and 600A Rated
                    </td>
                  </tr>
                </tbody>
              </table>

              <table id="communications">
                <tbody>
                  <tr>
                    <th>Communications</th>
                    <td className="left-align">
                      DMX-512, Modbus 485, Modbus TCP/IP, Bacnet IP, Web Server
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          ),
        },
        {
          title: 'Downloads',
          id: 'downloads',
          content: (
            <ul style={{ listStyle: 'none' }}>
              <li>
                <a href="/downloads/brochure-breaker-control-panelboard.pdf">
                  Product Brochure
                </a>
              </li>
            </ul>
          ),
        },
      ]}
    />
  );
}
